export async function getContactsApi(recID, email) {
  const requestOptions = {
    method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recID, email }),
  };
    const response = await fetch("mysmh/Contact/GetContacts", requestOptions);
  return await response.json();
}
